
<template>
<div>

  <div v-for="(item,index) in menu" :key="index" >
       <lk-submenu v-if="item.children && item.children.length" :name="item.name">
            <template slot="title">
              <!-- <lk-icon :type="item.icon" /> -->
            <span class="iconfont" v-if='item.icon' v-html='item.icon'></span>
             {{item.title}}
            </template>
            <submenu v-if='item.children.length' :menu='item.children'></submenu>
            <!-- <lk-menu-item v-for="(subItem,i) in item.children" :name="subItem.code"   :key="i" :to="{name:subItem.route}">{{subItem.title}}</lk-menu-item> -->
        </lk-submenu>
            <lk-menu-item  v-else  :name="item.name"   :key="index" :to={name:item.name} >
              <div class='menuItem'>
                <span>{{item.title}}</span>
                <!-- <span @click.stop='handleFavorite(item)'>
                  <lk-icon type='md-star' :class='{"collected":item.collected,"star":true}'></lk-icon>
                </span> -->
              </div>
            </lk-menu-item>
</div>
  </div>
</template>
<script>
// 递归调用组件，匹配树形菜单
// eslint-disable-next-line import/no-self-import
import submenu from './sideSubmenu.vue';

export default {
  name: 'submenu',
  components: {
    submenu,
  },
  props: {
    menu: {
      type: Array,
      // default:[],
    },
  },
  data() {
    return {
      // menu
      collected: false,
    };
  },
  methods: {

    handleFavorite() {
      this.collected = !this.collected;
    },
    favoriteDelete() {
      // console.log(this.$route);
    },
  },
  mounted() {

  },
};
</script>
<style lang="less" scoped>
.menuItem{
  display: flex;
  justify-content: space-between;
}
.star{
  color: rgba(255, 255, 255, 0.7)
}
.collected{
  color: #fff
}
</style>
